import React, { createElement } from 'react';
import { Arg1 } from 'tsargs';

interface MakeHocFromHookArgs<C extends (arg1: any) => any, K extends string> {
    propName: K;
    hook: C;
    input: Arg1<C>;
}

export type HookedProps<C extends (arg1: any) => any, K extends string> = {
    [key in K]: ReturnType<C>;
};

function makeHocFromHook<C extends (arg1: any) => any, K extends string>(
    args: MakeHocFromHookArgs<C, K>
) {
    const { hook, input, propName } = args;

    const withHook = <P extends HookedProps<C, K>>(
        Component: React.ComponentType<P>
    ) => {
        const BoundComponent = (props: Pick<P, Exclude<keyof P, K>>) => {
            const output: ReturnType<C> = hook(input);

            return createElement(Component, {
                ...(props as P),
                [propName]: output,
            });
        };

        return BoundComponent;
    };

    return withHook;
}

export default makeHocFromHook;
